export const LOCATION_AVAILABILITY_SNAPSHOT = {
  catalogVersion: "geonames:2026-06-22",
  sourceSnapshot: "2026-06-22",
  cityRecords: 21_166,
  geographies: 218,
} as const;

export const EQUIPMENT_CATALOG_SNAPSHOT = {
  catalogVersion: "2026-08-15.v2",
  droneModels: 265,
  manufacturers: 44,
} as const;

export const HOME_CONFIDENCE_METRICS = [
  { key: "industries", value: 11 },
  { key: "models", value: EQUIPMENT_CATALOG_SNAPSHOT.droneModels },
  { key: "cities", value: LOCATION_AVAILABILITY_SNAPSHOT.cityRecords },
  { key: "geographies", value: LOCATION_AVAILABILITY_SNAPSHOT.geographies },
] as const;
